import React from 'react';
import * as R from 'ramda';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    },
    circularProgress: {
      width: '48px',
      height: ' 48px',
      borderStyle: 'solid',
      borderWidth: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      boxSizing: 'border-box',
      animation: '$rotate 1s linear infinite',
      margin: theme.spacing(2),
      borderBottomColor: 'transparent !important'
    },
    '@keyframes rotate': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    warning: {
      borderColor: theme.palette.warning.main
    },
    primaryColor: {
      borderColor: theme.palette.primary.main
    },
    secondaryColor: {
      borderColor: theme.palette.secondary.main
    }
  };
});
var Loading = function Loading(_ref) {
  var _cx;
  var message = _ref.message,
    _ref$isWarning = _ref.isWarning,
    isWarning = _ref$isWarning === undefined ? false : _ref$isWarning,
    _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? 'primary' : _ref$variant,
    color = _ref.color;
  var classes = useStyles();
  return React.createElement('div', {
    className: classes.root
  }, React.createElement('div', {
    style: {
      color: R.isNil(color) ? undefined : color
    },
    className: cx(classes.circularProgress, (_cx = {}, _cx[classes[variant + 'Color']] = !R.isNil(variant) && R.isNil(color) && !isWarning, _cx[classes.warning] = isWarning, _cx))
  }), React.createElement(Typography, {
    variant: 'subtitle1',
    noWrap: true,
    align: 'center'
  }, message));
};
Loading.propTypes = process.env.NODE_ENV !== "production" ? {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.string,
  color: PropTypes.string,
  isWarning: PropTypes.bool
} : {};
export default Loading;